module.exports = __webpack_public_path__ + "static/property-3@2x-e4a7a23178585fafaa7df9ddb7d29ae4.jpg";